import { Button, PageTitle } from "@/_component/Common";
import MainAdsLayout from "@/_component/MainAdsLayout";
import { NO_IMAGE, S3_HOST } from "@/_constant";
import { Info, Success } from "@/_service/notification/notification";
import { fetchUserAccessList } from "@/apis";
import { useAuthContext, useLanguageContext } from "@/hooks";
import { useEffect, useState } from "react";

export default function MyPlan() {
    const { user } = useAuthContext();
    const {language} = useLanguageContext();

    const [userPlans, setUserPlans] = useState([]);

    const fetchAllUserPlans = () => {
        fetchUserAccessList(['APPROVED'])
            .then(res => {
                const plans = res.data.response.filter(plan => !['Farmer', 'Agent', 'Others'].includes(plan.access_name));
                console.log(plans);
                setUserPlans(plans);
            });
    }

    const handleUpdateOrRenewPlan = (plan) => {
        if(plan.userPlanStatus === 'PaymentInitiate'){
            Success("Your payment for this is pending, so you cannot upgrade this plan until it's completed...");
            return;
        }
        if(plan.plan_group === 'Diamond'){
            Info(language("msg.can_not_upgrade_this_plan"));
            return;
        }

    }

    useEffect(() => {
        fetchAllUserPlans();
    }, []);

    return (
        <MainAdsLayout sideBanner>
            <PageTitle headingPart1={"My"} headingPart2={"Plans"}></PageTitle>
            <div className="pe-lg-3">
                <div className="row row-cols-2 gx-3 gy-3">
                    {
                        userPlans.map(plan=> (
                            <div className="col" key={plan.access_id}>
                                <div className="card shadow-sm h-100">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="text-center col-5">
                                                <img src={S3_HOST+plan.category_thumbnail} alt="plan image" className="img-fluid rounded-circle" style={{maxWidth: "3rem", maxHeight: "3rem", aspectRatio:"2/2"}}/>
                                                <p className="text-sm">{language(plan.category_display_code)}</p>
                                            </div>
                                            <div className="col-7">
                                                <p className="text-sm">{language("label.your_current_plan")}</p>
                                                <p className="text-bold text-uppercase mt-2">{plan.plan_group}</p>
                                                <p className="text-sm mt-2">{language("label.total_listing")}: {plan.plan_listing}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <Button primary={plan.plan_days_remaining > 0} warning={plan.plan_days_remaining <= 0} hide={plan.plan_group === 'Diamond' && plan.plan_days_remaining > 0} solid rounded small onClick={()=> handleUpdateOrRenewPlan(plan)}>{plan.plan_days_remaining <=0 ? language("label.renew") : language("label.upgrade_plan")}</Button>
                                            <p>{plan.plan_days_remaining <= 0 ? language("label.expired_days_ago")?.replace("{remaining_days}", -plan.plan_days_remaining) : language("label.expiring_in_days")?.replace("{remaining_days}", plan.plan_days_remaining)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </MainAdsLayout>
    );
}